// react
import React, { useRef, useContext } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// hooks
import useNotifications from '../../hooks/useNotifications';
// styles
import { Button, Container, Form, Row, Col } from 'react-bootstrap';
import { Facebook } from 'react-bootstrap-icons';
import styles from './Login.module.css';
import googleLogo from '../../../app/assets/btn_google.svg';
import { useAnalytics, usePageView } from '../../hooks/useAnalytics';
import { AppContext, AccountContext } from '../../GlobalContex';

const Login = () => {
  const { t } = useTranslation();
  const notification = useNotifications();
  const { setIsLoading } = useContext(AppContext);
  usePageView('Login');

  const navigate = useNavigate();
  const location = useLocation();
  const { userEmail } = useParams();
  const { from } = location.state || { from: '/home' };

  const email = useRef(null);
  const password = useRef(null);

  const { sendEvent } = useAnalytics();

  const { signin, signinUsingSocialAuth } = useContext(AccountContext);

  const submitHandler = async e => {
    e.preventDefault();
    signin(email.current.value, password.current.value)
      .then(
        () => {
          sendEvent('login', {
            method: 'Email'
          });
          navigate(from);
        },
        err => {
          notification.warning(err.message);
        }
      )
      .finally();
  };

  async function signinWithService(service) {
    setIsLoading(true);
    try {
      await signinUsingSocialAuth(service.toLowerCase());
      sendEvent('login', { method: service });
      setIsLoading(false);
      navigate(from);
    } catch (err) {
      notification.warning(err.message);
      setIsLoading(false);
    }
  }

  return (
    <div className="bootstrap-app-styles h-100">
      <div className={'d-flex justify-content-center align-items-center h-100'}>
        <Container>
          <Row className="justify-content-center">
            <Col xs={12}>
              <Form onSubmit={e => submitHandler(e)}>
                <h5 className="text-center">{t('Login with')}</h5>
                <Row className="form-group mb-3 g-3">
                  <Col>
                    <Button
                      className={'w-100 shadow ' + styles.google__btn}
                      variant="white"
                      onClick={() => signinWithService('Google')}>
                      <img
                        width="24"
                        height="24"
                        src={googleLogo}
                        alt="google logo"
                        className="me-2"
                      />
                      Google
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      className={'w-100 shadow ' + styles.facebook__btn}
                      onClick={() => signinWithService('Facebook')}>
                      <Facebook size={24} className="me-2" />
                      Facebook
                    </Button>
                  </Col>
                </Row>
                <h5 className="text-center mb-3">{t('or')}</h5>
                <Form.Group controlId="loginFormEmail" className={'mb-3'}>
                  <Form.Control
                    type="email"
                    placeholder={t('Enter Email')}
                    ref={email}
                    onChange={e => {}}
                    value={userEmail || ''}
                  />
                </Form.Group>
                <Form.Group controlId="loginFormPassword" className={'mb-3'}>
                  <Form.Control type="password" placeholder={t('Password')} ref={password} />
                </Form.Group>
                <Form.Group className={'mb-3'}>
                  <Button type="submit" className="w-100">
                    {t('Log In')}
                  </Button>
                </Form.Group>
                <div className="text-center">
                  <Link to="/register">{t('Sign Up')}</Link>
                  {' / '}
                  <Link to="/forgot-password">{t('Forgot Password?')}</Link>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Login;
